import {Watch} from '@acng/frontend-relativity';
import {Engine, ElementSetup} from '@acng/frontend-stargazer';
import {
  HTMLElement,
  connectedCallback,
  defineElement,
  disconnectedCallback,
} from '@acng/frontend-bounty/dom/custom.js';
import {ctxAmateur} from '../context/amateur.js';
import {removeChildNodes} from '@acng/frontend-bounty';

/**
 * @group DOM Element
 */
const AMATEUR_LABEL = 'onsw-amateur-label';

ElementSetup(AMATEUR_LABEL, (name) => {
  const watch = Watch(name, ctxAmateur);
  const transclude = Engine.Transclude(name);

  defineElement(
    name,
    class extends HTMLElement {
      #engine = Engine.root;

      [connectedCallback]() {
        this.#engine = transclude(this);

        watch(this, (element, amateur) => {
          if (!amateur) {
            removeChildNodes(element);
            return;
          }

          this.#engine.toElement(
            element,
            {
              nickname: amateur.getNickname(),
              age: amateur.age,
              description: amateur.getDescription(),
              from: amateur.from,
            },
          );
        });
      }

      [disconnectedCallback]() {
        this.#engine.disconnect();
      }
    }
  );
});
